<template>
  <section id="skills-section" class="common-padding mb-20">
    <div class="flex flex-col">
      <h3
        id="skillsTitle"
        v-html="skillsTitle"
        class="heading-1 text-start leading-none font-bold uppercase"
      ></h3>
      <p
        class="heading-1 text-flax-smoke-400 text-opacity-50 hidden w-4/5 text-end font-extrabold sm:block"
      >
        <!-- Removed the counter -->
      </p>

      <div
        id="skills-text"
        class="md:column-gap text-flax-smoke-300 mt-[5%] grid grid-cols-1 sm:grid-cols-12 justify-end opacity-0"
      >
        <p
          class="heading-6 text-flax-smoke-300/85 col-span-full sm:col-span-4 sm:text-center text-left sm:text-center text-nowrap lg:col-start-2"
        >
          ( TECHNOLOGIES )
        </p>
        <p
          class="heading-4 font-fancy col-span-full sm:col-span-8 w-full text-balance sm:font-semibold lg:col-span-7"
        >
          Technical expertise across full-stack development, data analysis, and AI/ML.
        </p>
      </div>
    </div>

    <div class="mt-12 space-y-8 lg:mt-[10%]">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- Languages -->
        <div class="skills-category">
          <h4 class="heading-3 font-title! font-bold uppercase text-flax-smoke-100 mb-4">
            Languages
          </h4>
          <div class="flex flex-wrap gap-3">
            <span
              v-for="skill in skillsData.languages"
              :key="skill"
              class="border-flax-smoke-300 text-flax-smoke-300 hover:bg-flax-smoke-300 hover:text-flax-smoke-900 rounded-full border px-4 py-2 text-base transition-[background-color,color] duration-300"
            >
              {{ skill }}
            </span>
          </div>
        </div>

        <!-- Frameworks & Libraries -->
        <div class="skills-category">
          <h4 class="heading-3 font-title! font-bold uppercase text-flax-smoke-100 mb-4">
            Frameworks & Libraries
          </h4>
          <div class="flex flex-wrap gap-3">
            <span
              v-for="skill in skillsData.frameworks"
              :key="skill"
              class="border-flax-smoke-300 text-flax-smoke-300 hover:bg-flax-smoke-300 hover:text-flax-smoke-900 rounded-full border px-4 py-2 text-base transition-[background-color,color] duration-300"
            >
              {{ skill }}
            </span>
          </div>
        </div>

        <!-- AI/ML, Cloud, DevOps & Developer Tools -->
        <div class="skills-category">
          <h4 class="heading-3 font-title! font-bold uppercase text-flax-smoke-100 mb-4">
            AI/ML, Cloud, DevOps & Developer Tools
          </h4>
          <div class="flex flex-wrap gap-3">
            <span
              v-for="skill in skillsData.tools"
              :key="skill"
              class="border-flax-smoke-300 text-flax-smoke-300 hover:bg-flax-smoke-300 hover:text-flax-smoke-900 rounded-full border px-4 py-2 text-base transition-[background-color,color] duration-300"
            >
              {{ skill }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { animateSplitText } from '@/animations';
  import { textSplitterIntoChar } from '@/functions';
  import { onBeforeMount, onMounted, ref } from 'vue';

  const skillsTitle = ref('Skills /');

  const skillsData = {
    languages: [
      'Python',
      'Java',
      'TypeScript',
      'SQL (PostgreSQL)',
      'JavaScript',
      'HTML/CSS'
    ],
    frameworks: [
      'React',
      'Next.js',
      'Spring Boot',
      'FastAPI',
      'Prisma ORM',
      'Node.js',
      'Express.js',
      'Tailwind CSS'
    ],
    tools: [
      'PyTorch',
      'LangChain',
      'OpenCV',
      'Google Cloud Platform',
      'Microsoft Azure',
      'Azure AI',
     'Power BI',
      'Amazon Web Services (AWS)',
      'Git',
      'GitHub Actions',
      'Docker',
      // 'JUnit',
      // 'Jira',
      // 'Agile Methodology',
      // 'Software Development Life Cycle (SDLC)'
    ]
  };

  onBeforeMount(() => {
    skillsTitle.value = textSplitterIntoChar('Skills / ', true);
  });

  onMounted(() => {
    animateSplitText(
      '#skillsTitle .letters',
      '#skills-text',
      0.7,
      0.01,
      0,
    );
  });
</script>

<style scoped>
  .skills-category {
    @apply flex flex-col;
  }
</style>
